export enum RestrictionTypes {
  Tier_Upgrade = 'tier_upgrade',
  Payment_Due = 'payment_due',
  Add_On_Feature = 'add_on_feature',
  canceled  = 'canceled'
}

export enum subscribedFeatures {
  'SITE_SEQUENCER' = 'SITE_SEQUENCER',
  'EQUIPMENT_BUILDER' = 'EQUIPMENT_BUILDER'
}

export enum TierId {
  AddOns = 'AddOns',
}

export const redirectCta = {
  UpgradeNow: 'Upgrade Now',
  RenewNow: 'Renew Now',
  EnableAddOn: 'Enable Add On',
  ReactivateNow: 'Reactivate Now'
}

export const subscriptionState = {
  active: 'active',
  canceled: 'canceled',
  expired: 'expired',
  onHold: 'on_hold'
}

export const inactiveSubscriptionStates = [
  subscriptionState.expired,
  subscriptionState.canceled,
  subscriptionState.onHold
];